@import '../../../../../../constants/spacing.module.less';

.inventory-banner {
  max-width: 808px;
  margin: @space-24 0 @space-32;

  .inventory-banner-button {
    margin-top: @space-4;
    white-space: nowrap;
  }
}
